import { render, staticRenderFns } from "./redirections-form.view.vue?vue&type=template&id=7d982736"
import script from "./redirections-form.view.vue?vue&type=script&lang=ts"
export * from "./redirections-form.view.vue?vue&type=script&lang=ts"
import style0 from "./redirections-form.view.vue?vue&type=style&index=0&id=7d982736&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports